<div class="card card-tabs">
	<div class="card-body">
		<label for="" class="title-history">
			Histórico de Procesos Productivos
		</label>
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<input type="radio" name="pcss3t" [appCheckPermission]="[5083]" [permissionType]="permissionType.ALL"
				[(ngModel)]="history" [value]="0" checked id="tab1">
			<label for="tab1" [appCheckPermission]="[5083]" [permissionType]="permissionType.ALL">
				<i class="fa fa-list-1-2"></i>Histórico de Procesos Productivos
			</label>

		</div>
		<app-history-production [hidden]="history!=0" *ngIf="history==0"></app-history-production>
	</div>
</div>